/**
 * AboutUs - Footer about us section
 *
 * Data from centralized config (lib/footerConfig.ts)
 */

import { FooterLinkSection } from './FooterLinkSection'
import { aboutUsSection } from '../../lib'

export function AboutUs() {
  return <FooterLinkSection data={aboutUsSection} />
}
